import { createBrowserRouter } from "react-router-dom";

// Consultancy Layouts
import ConsultancyLayout from "../Layouts/ConsultancyLayout";
import AboutPage from "../Pages/AboutPage";
import BlogDetailPage from "../Pages/Blogs/BlogDetailPage";
import BlogPage01 from "../Pages/Blogs/BlogPage01";
import BlogPage02 from "../Pages/Blogs/BlogPage02";
import BlogPage03 from "../Pages/Blogs/BlogPage03";
import ContactPage from "../Pages/ContactPage";
import FAQ from "../Pages/FAQ";
import ConsultancyHome from "../Pages/HomePages/ConsultancyHome";
import Services01 from "../Pages/Services/Service01";
import ServiceDetails from "../Pages/Services/ServiceDetails";
import TeamPage from "../Pages/TeamPage";
import Pricing from "../Pages/Pricing/index";
import Feature from "../Pages/Feature/Feature";

// Business Layouts
import BusinessLayout from "../Layouts/BusinessLayout";
import BusinessHome from "../containers/Business/BusinessHome";

// InvestMent Layouts
import InvestmentLayout from "../Layouts/InvestmentLayout";
import InvestmentHome from "../containers/Investment/InvestmentHome";

// Insurance Layouts
import InsuranceLayout from "../Layouts/InsuranceLayout";
import InsuranceHome from "../containers/Insurance/InsuranceHome";

// Shared Layout
import ErrorPage from "../Pages/ErrorPage/ErrorPage";
import Enrollment from "../Pages/Enrollment";
import Scholarship from "../Pages/Scholarship"
import Dashboard from "../Pages/NewDashboard/Dashboard";
import AcademicManagement from "../Pages/Product&Soluction/AcademicManagement";
import AdmissionEnrollment from "../Pages/Product&Soluction/Admission&Enrollment";
import AdministrativeConsole from "../Pages/Product&Soluction/AdministrativeConsole";
import DynamicWebsiteforSchoolst from "../Pages/Product&Soluction/DynamicWebsiteforSchoolst";
import InternationalCurriculumDevelopment from "../Pages/Product&Soluction/InternationalCurriculumDevelopment";
import StudentInformationSystem from "../Pages/Product&Soluction/StudentInformationSystem";
import ParentManagementSystem from "../Pages/Product&Soluction/ParentManagementSystem";
import HRMS from "../Pages/Product&Soluction/HRMS";
import LearningManagementSystem from "../Pages/Product&Soluction/LearningManagementSystem";
import AdmissionAndEnrollmentReadmore from "../Pages/Product&Soluction/read-more/AdmissionReadmore"
import StudentInformationSystemReadmore from "../Pages/Product&Soluction/read-more/StudentInformationSystemReadmore"
import LmsReadmore from "../Pages/Product&Soluction/read-more/LmsReadmore";
import DynamicWebsiteForSchoolsReadmore from "../Pages/Product&Soluction/read-more/DynamicWebsiteForSchoolsReadmore";
import ContactSales from "../components/ConsultancyElements/ContactSales";
import UpdateFAQ from "../components/common/UpdateFAQ";
import UserEmailRate from "../Pages/UserRating/UserEmailRate";
import LoginPage from "../Pages/Auth/Login/index"
import SignupPage from "../Pages/Auth/Sign-up/index"

export const routes = createBrowserRouter([
  {
    path: "/rate-us",
    element: <UserEmailRate />,
  },
  {
    path: "/",
    element: <ConsultancyLayout />,
    children: [
      {
        path: "/",
        element: <ConsultancyHome />,
      },
      {
        path: "/service",
        element: <Services01 />,
      },
      {
        path: "/auth/login",
        element: <LoginPage />,
      },
      {
        path: "/auth/sign-up",
        element: <SignupPage />,
      },
      {
        path: "/service-2",
        element: <Services01 />,
      },
      {
        path: "/service-details",
        element: <ServiceDetails />,
      },
      {
        path: "/about",
        element: <AboutPage />,
      },
      {
        path: "/team",
        element: <TeamPage />,
      },
      {
        path: "/faq",
        element: <FAQ />,
      },
      {
        path: "/add-faq",
        element: <UpdateFAQ />,
      },
      {
        path: "/blog",
        element: <BlogPage01 />,
      },
      {
        path: "/academic-management",
        element: <AcademicManagement />,
      },
      {
        path: "/academic-management/lms-readmore",
        element: <LmsReadmore />,
      },
      {
        path: "/admission-enrollment",
        element: <AdmissionEnrollment />,
      },

      {
        path: "/admission-enrollment/read-more",
        element: <AdmissionAndEnrollmentReadmore />,
      },
      {
        path: "/contact-sales",
        element: <ContactSales />,
      },
      {
        path: "/dynamic-web/read-more",
        element: <DynamicWebsiteForSchoolsReadmore />,
      },
      {
        path: "/administrative-console",
        element: <AdministrativeConsole />,
      },
      {
        path: "/dynamic-website-for-schoolst",
        element: <DynamicWebsiteforSchoolst />,
      },
      {
        path: "/international-curriculum-development",
        element: <InternationalCurriculumDevelopment />,
      },
      {
        path: "/student-information-system",
        element: <StudentInformationSystem />,
      },
      {
        path: "/parent-management-system",
        element: <ParentManagementSystem />,
      },
      {
        path: "/pms",
        element: <ParentManagementSystem />,
      },
      {
        path: "/hrms",
        element: <HRMS />,
      },
      {
        path: "/learning-management-system",
        element: <LearningManagementSystem />,
      },
      {
        path: "/lms",
        element: <LearningManagementSystem />,
      },
      {
        path: "/student-information-system/read-more",
        element: <StudentInformationSystemReadmore />,
      },
      {
        path: "/blog-2",
        element: <BlogPage02 />,
      },
      {
        path: "/blog-3",
        element: <BlogPage03 />,
      },
      {
        path: "/blog-details/:id",
        element: <BlogDetailPage />,
      },
      {
        path: "/contact",
        element: <ContactPage />,
      },
      {
        path: "*",
        element: <ErrorPage />,
      },
      {
        path: "/pricing",
        element: <Pricing />,
      },
      {
        path: "/feature",
        element: <Feature />,
      },
      // {
      //   path: '/enrollment',
      //   element: <Enrollment />
      // },
      {
        path: "/scholarship",
        element: <Scholarship />,
      },
    ],
  },

  {
    path: "/business",
    element: <BusinessLayout />,
    children: [
      {
        path: "/business",
        element: <BusinessHome />,
      },
      {
        path: "*",
        element: <ErrorPage />,
      },
    ],
  },
  {
    path: "/investment",
    element: <InvestmentLayout />,
    children: [
      {
        path: "/investment",
        element: <InvestmentHome />,
      },
      {
        path: "*",
        element: <ErrorPage />,
      },
    ],
  },
  {
    path: "/insurance",
    element: <InsuranceLayout />,
    children: [
      {
        path: "/insurance",
        element: <InsuranceHome />,
      },
      {
        path: "*",
        element: <ErrorPage />,
      },
    ],
  },
]);
